/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 24, 2026 by hoarfroster
 *
 */

import { getStorageItem, setStorageItem, setCookie } from '@utils/storage';

export default async function httpRequest(
    url: string,
    method: string,
    body?: unknown,
    stringifyBody = true
): Promise<Response> {
    const headers: Record<string, string> = {
        Authorization: getStorageItem('token') ?? '',
    };

    const isFormData = typeof FormData !== 'undefined' && body instanceof FormData;

    // Only set JSON content type when we stringify and body isn't FormData
    if (!isFormData && stringifyBody) {
        headers['Content-Type'] = 'application/json';
    }

    const requestBody: BodyInit | undefined =
        body == null ? undefined : isFormData ? body : stringifyBody ? JSON.stringify(body) : (body as BodyInit);

    const response = await fetch(url, {
        method,
        headers,
        body: requestBody,
    });

    if (response.status === 403) {
        try {
            const clone = response.clone();
            const json = await clone.json();

            if (json?.code === 401002) {
                // Clear token from storage so that the user is effectively logged out
                setStorageItem('token', '');
                setStorageItem('user-info', '');
                setCookie('token', '', { expires: new Date(0) });

                // Dispatch a global event so the App can show a re-sign-in modal
                window.dispatchEvent(new CustomEvent('auth-intercept', { detail: json }));

                // HALT EXECUTION: Return an unresolved Promise.
                // This completely halts the async chain here. Model execution stops, and UI components
                // simply wait forever. They will never reach `await response.json()` nor `catch (_e)`.
                return new Promise<Response>(() => {
                    // Intentionally never resolves to halt execution
                });
            }
        } catch {
            // Ignore parsing errors for 403 and fall through
        }
    }

    return response;
}
